import * as Yup from 'yup';

export const validateSchema = () => {
    return Yup.object({
        postcode: Yup.string()
            .required("This field is required and should be a number.")
            .min(3, 'Invalid Postcode. Please check that the postcode you entered is correct.')
            .max(4, 'Invalid Postcode. Please check that the postcode you entered is correct.')
    });
};

export const validateEmail = () => {
    return Yup.object({
        email: Yup.string()
            .email('Please provide a valid email address.')
            .required('Please provide an email address to send result!')
    });
};
